(function ($, window, document) {
    'use strict';

    if (!$ || !$('.type-category').length) {
        return;
    }

    var CategoryTextsStorage = {
        debug: true,

        selectors: {
            perex: '.category-perex',
            secondDescription: '.category__secondDescription',
            title: '.category-title',
            categoryTop: '.category-top',
            productsTarget: '.pagination-wrapper, .pagination, .products-block, .products, #products, .product-list',
            contentFallback: 'main#content, #content'
        },

        log: function () {
            if (!this.debug || !window.console) {
                return;
            }

            var args = Array.prototype.slice.call(arguments);
            args.unshift('[CategoryTextsStorage]');
            console.log.apply(console, args);
        },

        getProjectId: function () {
            if (typeof window.getShoptetDataLayer === 'function') {
                var projectId = window.getShoptetDataLayer('projectId');

                if (projectId) {
                    return projectId;
                }
            }

            return 'default';
        },

        getStorageName: function () {
            return 'categoryTexts:' + this.getProjectId();
        },

        getBasePath: function () {
            return window.location.pathname.replace(/\/strana-\d+\/?$/, '/');
        },

        isPaginationPage: function () {
            return /\/strana-\d+\/?$/.test(window.location.pathname);
        },

        getStorage: function () {
            var rawData = sessionStorage.getItem(this.getStorageName());

            if (!rawData) {
                return {};
            }

            try {
                return JSON.parse(rawData) || {};
            } catch (e) {
                this.log('Storage nejde načíst, resetuji.', e);
                return {};
            }
        },

        setStorage: function (data) {
            try {
                sessionStorage.setItem(this.getStorageName(), JSON.stringify(data));
                this.log('Storage uložena:', data);
            } catch (e) {
                this.log('Storage nejde uložit.', e);
            }
        },

        saveText: function (path, key, html) {
            if (!path || !key || !html || $.trim(html) === '') {
                return;
            }

            var data = this.getStorage();

            if (!data[path]) {
                data[path] = {};
            }

            data[path][key] = html;

            this.setStorage(data);
            this.log('Uloženo:', path, key);
        },

        getText: function (path, key) {
            var data = this.getStorage();

            if (!data[path] || !data[path][key]) {
                this.log('Nenalezeno ve storage:', path, key);
                return null;
            }

            this.log('Načteno ze storage:', path, key);

            return data[path][key];
        },

        saveCurrentPageTexts: function () {
            if (this.isPaginationPage()) {
                this.log('Stránkovaná URL, DOM neukládám.');
                return;
            }

            var path = this.getBasePath();

            var $perex = $(this.selectors.perex).first();

            if ($perex.length) {
                this.saveText(path, 'perex', $perex.prop('outerHTML'));
            }

            var $secondDescription = $(this.selectors.secondDescription).first();

            if ($secondDescription.length) {
                this.saveText(path, 'secondDescription', $secondDescription.prop('outerHTML'));
            }
        },

        renderFromStorage: function () {
            if (!this.isPaginationPage()) {
                return;
            }

            var path = this.getBasePath();

            this.renderPerex(path);
            this.renderSecondDescription(path);
        },

        renderPerex: function (path) {
            if ($(this.selectors.perex).length) {
                return;
            }

            var perexHtml = this.getText(path, 'perex');

            if (!perexHtml) {
                return;
            }

            var $title = $(this.selectors.title).first();

            if ($title.length) {
                $title.after(perexHtml);
                this.log('Perex vložen za H1.');
            }
        },

        renderSecondDescription: function (path) {
            if ($(this.selectors.secondDescription).length) {
                return;
            }

            var secondDescriptionHtml = this.getText(path, 'secondDescription');

            if (!secondDescriptionHtml) {
                return;
            }

            var $target = $(this.selectors.productsTarget).last();

            if ($target.length) {
                $target.after(secondDescriptionHtml);
                this.log('Druhý popisek vložen za produkty/paginaci.');
            } else {
                $(this.selectors.contentFallback).first().append(secondDescriptionHtml);
                this.log('Druhý popisek vložen na konec contentu.');
            }
        },

        fetchBasePageTexts: function (callback) {
            var self = this;

            if (!self.isPaginationPage()) {
                return;
            }

            var path = self.getBasePath();
            var data = self.getStorage();

            if (data[path] && data[path].perex && data[path].secondDescription) {
                self.log('Storage už obsahuje perex i druhý popisek, AJAX přeskakuji.');

                if (typeof callback === 'function') {
                    callback();
                }

                return;
            }

            self.log('Načítám první stránku kategorie:', path);

            $.get(path)
                .done(function (response) {
                    var $html = $('<div>').html(response);

                    var $perex = $html.find(self.selectors.perex).first();
                    var $secondDescription = $html.find(self.selectors.secondDescription).first();

                    if ($perex.length) {
                        self.saveText(path, 'perex', $perex.prop('outerHTML'));
                    }

                    if ($secondDescription.length) {
                        self.saveText(path, 'secondDescription', $secondDescription.prop('outerHTML'));
                    }

                    self.renderFromStorage();

                    if (typeof callback === 'function') {
                        callback();
                    }
                })
                .fail(function (xhr, status, error) {
                    self.log('Nepodařilo se načíst první stránku kategorie.', status, error);
                });
        },

        processPerexHashToggle: function () {
            var hashRegex = /(^|[^/])#(?!\/)/;

            $(this.selectors.perex).each(function () {
                var $perex = $(this);

                if ($perex.hasClass('js-hash-processed')) {
                    return;
                }

                var $markerParagraph = $perex.find('p').filter(function () {
                    return hashRegex.test($.trim($(this).text()));
                }).first();

                if (!$markerParagraph.length) {
                    return;
                }

                var markerText = $.trim($markerParagraph.text());

                if (markerText === '#') {
                    var $hiddenNodes = $markerParagraph.nextAll();

                    $markerParagraph.remove();

                    if (!$hiddenNodes.length) {
                        $perex.addClass('js-hash-processed');
                        return;
                    }

                    $hiddenNodes.wrapAll('<div class="category-perex-hidden"></div>');
                    $perex.find('.category-perex-hidden').hide();
                } else {
                    var splitMatch = markerText.match(/^(.*?)#([\s\S]+)$/);

                    if (!splitMatch || !$.trim(splitMatch[2]).length) {
                        return;
                    }

                    $markerParagraph
                        .text($.trim(splitMatch[1]) + ' ')
                        .append('<span class="category-perex-hidden">' + $.trim(splitMatch[2]) + '</span>');

                    $markerParagraph.find('.category-perex-hidden').hide();
                }

                if (!$perex.find('> .category-perex-toggle').length) {
                    $perex.append('<button type="button" class="category-perex-toggle">Zobrazit více</button>');
                }

                $perex.addClass('js-hash-processed');
            });
        },

        processCategoryPerexExtras: function () {
            var self = this;

            var $categoryTop = $(self.selectors.categoryTop).first();
            var $perex = $(self.selectors.perex).first();
            var $secondDescription = $(self.selectors.secondDescription).last();

            if (!$perex.length) {
                return;
            }

            if (
                $categoryTop.length &&
                $perex.find('.help').length &&
                !$categoryTop.find('> .help').length
            ) {
                $categoryTop.append($perex.find('.help').first().clone());
                self.log('.help z perexu vložen do .category-top.');
            }

            if (
                $perex.find('> p').length > 1 &&
                !$perex.hasClass('empty-content') &&
                $secondDescription.length &&
                $.trim($secondDescription.text()).length > 1 &&
                !$perex.find('> .moreInfo').length
            ) {
                $perex.append('<span class="moreInfo">Více informací</span>');
                self.log('.moreInfo vloženo do perexu.');
            }
        },

        bindEvents: function () {
            var self = this;

            $(document)
                .off('click.categoryPerexToggle')
                .on('click.categoryPerexToggle', '.category-perex-toggle', function () {
                    var $button = $(this);
                    var $perex = $button.closest('.category-perex');
                    var $hiddenText = $perex.find('.category-perex-hidden').first();

                    if (!$hiddenText.length) {
                        return;
                    }

                    $hiddenText.toggle();

                    $button.text(
                        $hiddenText.is(':visible') ? 'Zobrazit méně' : 'Zobrazit více'
                    );
                });

            $(document)
                .off('click.categoryMoreInfo')
                .on('click.categoryMoreInfo', '.category-perex .moreInfo', function () {
                    var $secondDescription = $(self.selectors.secondDescription).last();

                    $('.category-perex').toggleClass('opened');

                    if (!$secondDescription.length) {
                        return;
                    }

                    $('html, body').animate({
                        scrollTop: $secondDescription.offset().top - 50
                    }, 500);
                });
        },

        sync: function () {
            var self = this;

            self.saveCurrentPageTexts();
            self.renderFromStorage();

            self.fetchBasePageTexts(function () {
              //  self.processPerexHashToggle();
                self.processCategoryPerexExtras();
            });

           //self.processPerexHashToggle();
            self.processCategoryPerexExtras();
        },

        bindShoptetEvents: function () {
            var self = this;

            document.addEventListener('ShoptetDOMPageContentLoaded', function () {
                self.sync();
            });

            document.addEventListener('ShoptetPageSortingChanged', function () {
                self.sync();
            });

            document.addEventListener('ShoptetDOMPageMoreProductsLoaded', function () {
                self.sync();
            });

            document.addEventListener('ShoptetDOMContentLoaded', function () {
                self.sync();
            });
        },

        init: function () {
            this.bindEvents();
            this.bindShoptetEvents();
            this.sync();
        }
    };

    window.CategoryTextsStorage = CategoryTextsStorage;

    $(document).ready(function () {
        CategoryTextsStorage.init();
    });

})(window.jQuery, window, document);